import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  HomeIcon,
  MagnifyingGlassIcon,
  StarIcon,
  ClockIcon,
  TagIcon,
  UserIcon,
  HeartIcon
} from "@heroicons/react/24/outline";
// import { HeartIcon } from "@heroicons/react/24/solid";

import { useSelector } from "react-redux";
// import CategorySelectModal from "../../component/ui/CategorySelectModal.js";

function Nav() {
  const token = useSelector((state) => state.auth.token);
  const [modalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleCategorySelect = (categoryId) => {
    navigate(`/categories/${categoryId}`);
    setModalOpen(false);
  };

  return (
    <>
      <nav className="flex flex-col gap-16 my-auto ">
        <Link to="/">
          <NavItem icon={<HomeIcon className="h-10 w-10 shrink-0" />} title="Home" />
        </Link>
        <Link to="/search">
          <NavItem icon={<MagnifyingGlassIcon className="h-10 w-10 shrink-0"/>} title="Search" />
        </Link>
        <Link to="/favorites">
          <NavItem icon={<HeartIcon className="h-10 w-10 shrink-0"/>} title="Favoriti" />
        </Link>
        <Link to="/continuewatching">
          <NavItem icon={<ClockIcon className="h-10 w-10 shrink-0"/>} title="Continue a Guardare" />
        </Link>

        {/* Categories as Modal Trigger */}
        <Link to="/categoria">
          <NavItem icon={<TagIcon className="h-10 w-10 shrink-0"/>} title="Categoria" />
        </Link>

        {token && (
          <Link to="/profilo">
            <NavItem icon={<UserIcon className="h-10 w-10 shrink-0"/>} title="Profilo" />
          </Link>
        )}
      </nav>

      {/* Category Selection Modal */}
      {/* <CategorySelectModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelect={handleCategorySelect}
      /> */}
    </>
  );
}

export default Nav;

function NavItem({ icon, title }) {
  return (
    <div className="flex justify-center whitespace-nowrap align-middle text-stone-50 hover:text-red-500 transition-colors duration-200">
      <span className="flex h-10 w-10 items-center justify-center">
        {icon}
      </span>
      {/* <span className="sidebar__nav-title">{title}</span> */}
    </div>
  );
}